<template>
  <el-button v-bind="$attrs" v-on="$listeners" round class="aprove-button">
    <i class="fas fa-check"></i> Aprovar
  </el-button>
</template>

<script>
export default {
  name: 'aprove-button'
}
</script>

<style lang="scss" scoped>
  .aprove-button {
    padding: 14px 0;
    color: #fff;
    text-align: center;
    border-radius: 50%;
    position: fixed;
    z-index: 10;
    cursor: pointer;
    bottom: 20px;
    right: 36px;
    margin-left: 3px;
    background-color: #3ac25b;
    border-color: #3ac25b;

    &:hover, &:focus {
      background-color: #37b857;
      border-color: #37b857;
      color:#fff;
    }
  }

</style>
